<div class="schedule-action">
  <button
    class="menu-button"
    mat-button
    [matMenuTriggerFor]="menu"
    title="Menu"
    data-test="schedule-list-dropdown-menu"
  >
    <capra-icon icon="icon-kebab"></capra-icon>
    <mat-menu class="select-menu" #menu="matMenu" xPosition="before" (closed)="(null)">
      <button
        (click)="createOrDeleteSubscription.emit()"
        class="menu__item"
        data-test="subscribe-menu-item"
        mat-menu-item
        *ngIf="schedule.hasSubscription && !schedule.hasSlackSubscription && schedule.canSubscribeToSchedule"
      >
        <capra-icon *ngIf="schedule.subscribed" icon="icon-check" data-test="subscribed-to-schedule-icon"></capra-icon>
        Subscribe to schedule
      </button>
      <mat-divider *ngIf="schedule.canEditSchedule && schedule.hasSubscription && !schedule.hasSlackSubscription"></mat-divider>
      <button
        *ngIf="schedule.canEditSchedule"
        (click)="editSchedule.emit()"
        class="menu__item"
        data-test="edit-schedule-menu-item"
        mat-menu-item
      >
        Edit schedule
      </button>
      <button
        *ngIf="schedule.canDeleteSchedule"
        (click)="deleteSchedule.emit()"
        class="menu__item"
        data-test="delete-schedule-menu-item"
        mat-menu-item
      >
        Delete schedule
      </button>
    </mat-menu>
  </button>
</div>
